<template>
  <div v-cloak class="my-profile-contailer">
    <div class="caret-square">
      <i class="fa fa-arrow-circle-left cursor fa-2x " aria-hidden="true" @click="$router.go(-1);"></i>
      &nbsp;
      <span class="title">Banner Details</span>
    </div>

    <el-dialog
      title="Store Pictures"
      :visible.sync="confirmToShowPicturesDialogVisible"
      :close-on-click-modal="true"
      :center="true">
      <div class="dialog">
        <img src="https://sfa.itfsm.com/image-shower/73003E1E626C42A3A98BBDB3F965C939.jpg"/>

      </div>
      <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="confirmToShowPicturesDialogVisible = false">Close</el-button>
            </span>
    </el-dialog>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li>
          <small> {{this.$route.query.name}}</small>
        </li>
        <li class="active">
          <small>Banner detail</small>
        </li>
      </ol>
    </div>

    <div class="area-store-information">
      <span><b>Banner Information</b></span>
      <div  class="store-information">
        <banner-information :bannerId="this.$route.query.id"></banner-information>
      </div>
    </div>

    <div class="area-store-pictures">
      <span><b>Banner RD Detail</b></span>
      <div  class="store-pictures">
        <banner-rd-detail :bannerId="this.$route.query.bannerId"></banner-rd-detail>
      </div>
    </div>

    <div class="area-operation-log">
      <span><b>Operation Log</b></span>
      <div class="store-operation-log">
        <banner-operation-log :bannerId="this.$route.query.bannerId"></banner-operation-log>
      </div>
    </div>

  </div>
</template>

<script>
import { openExternal } from "@/util/openExternal";
  import bannerInformation from '@/view/store/banner_master/banner_information.vue'
  import bannerRdDetail from '@/view/store/banner_master/banner_rd_detail.vue'
  import bannerOperationLog from '@/view/store/banner_master/banner_operation_log.vue'

  export default {
    components: {
      bannerInformation,
      bannerOperationLog,
      bannerRdDetail
    },
    data() {
      return {
        prevPageName: '',
        confirmToShowPicturesDialogVisible: false
      }
    },
    computed: {
    },
    created() {
    },


    methods: {
      handleClickPictures(){
        openExternal('https://sfa.itfsm.com/image-shower/73003E1E626C42A3A98BBDB3F965C939.jpg');
      }
    }
  }

</script>

<style lang="scss" scoped>
  .my-profile-contailer {
    padding: 10px;
  }

  .title {
    font-size: 20px;
  }

  .caret-square {
    margin-left: 15px;
  }

  .content-wrapper /deep/ .content {
    padding: 0px;
    margin-top: -18px;
    margin-left: -10px;
  }
  .store-information{
    margin-top: -25px;
  }
  .area-store-information{
    background-color: white;
    padding: 10px;
  }
  .area-store-pictures{
    margin-top: 10px;
    background-color: white;
    padding: 10px;
  }
  .store-pictures{
    text-align: center;
  }
  .area-operation-log{
    margin-top: 10px;
    background-color: white;
    padding: 10px;
  }
  .store-operation-log{

  }
</style>



// WEBPACK FOOTER //
// src/view/store/banner_master/banner_detail.vue